import { render } from "./Pictures.vue?vue&type=template&id=6e04d150&scoped=true"
import script from "./Pictures.vue?vue&type=script&lang=js"
export * from "./Pictures.vue?vue&type=script&lang=js"

import "./Pictures.vue?vue&type=style&index=0&id=6e04d150&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e04d150"]])

export default __exports__